module.exports = __webpack_public_path__ + "static/Jan Szczepkowski w czasacj krakowskich, ok. 1900-1914-08bea0181aabae1664205f90e0d94c29.jpg";